import * as request from '@/utils/request'

const BASE_URL = '/paas/khl_ai_order'

export default {
  getKhlAiOrderList(data) {
    return request.post(`${BASE_URL}/list`, data)
  },
  getKhlAiOrderInfo(data) {
    return request.post(`${BASE_URL}/get_info`, data)
  },
  auditKhlAiOrder(data) {
    return request.post(`${BASE_URL}/audit`, data)
  },
  getKhlAiOrderAuthCompanyList(data) {
    return request.post(`${BASE_URL}/auth_company_list`, data)
  },
  getKhlAiOrderJoinList(data) {
    return request.post(`${BASE_URL}/join_list`, data)
  },
  auditKhlAiOrderJoin(data) {
    return request.post(`${BASE_URL}/join_audit`, data)
  },
  getKhlAiOrderDeliverList(data) {
    return request.post(`${BASE_URL}/deliver_list`, data)
  },
  getKhlAiOrderDeliverInfo(data) {
    return request.post(`${BASE_URL}/deliver_info`, data)
  },
  updateKhlAiOrderDeliver(data) {
    return request.post(`${BASE_URL}/deliver_update`, data)
  },
  auditKhlAiOrderDeliver(data) {
    return request.post(`${BASE_URL}/deliver_audit`, data)
  },
  getKhlAiOrderDeliverRejectInfo(data) {
    return request.post(`${BASE_URL}/deliver_reject_info`, data)
  }
}
